export interface Shop {
  id: string;
  name: string;
  prefecture: string;
  city: string;
  address: string;
  phone: string;
  phoneDisplay: string;
  businessHours: string;
  holiday: string;
  traderType: string;
  description?: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface ServiceItem {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export interface StepItem {
  step: number;
  title: string;
  description: string;
  icon: string;
}

export interface VoiceItem {
  name: string;
  age: string;
  car: string;
  comment: string;
}

export const shopDetail: Shop = {
  id: "114907",
  name: "アイチモータース",
  prefecture: "愛知県",
  city: "知多市",
  address: "愛知県知多市八幡字勘右エ門沢81-2",
  phone: "0562349210",
  phoneDisplay: "0562-34-9210",
  businessHours: "09:00〜17:00",
  holiday: "日曜・祝日",
  traderType: "4輪",
  description: "知多市で長年愛される自動車整備・販売専門店。車検、一般整備、板金塗装、LEDヘッドライト取付まで、お車のことなら何でもお任せください。",
};

export const faqItems: FaqItem[] = [
  {
    question: "車検は予約が必要ですか？",
    answer: "はい、事前予約をお願いしております。お電話にてご予約ください。混雑状況により、当日受付も可能な場合がございますが、事前予約が確実です。",
  },
  {
    question: "整備の見積もりは無料ですか？",
    answer: "はい、点検・見積もりは無料で承っております。お車をご持参いただくか、症状をお電話でお聞かせください。",
  },
  {
    question: "LEDヘッドライトの取付はどのくらい時間がかかりますか？",
    answer: "車種によりますが、一般的に30分〜1時間程度で完了いたします。事前にお電話で車種をお伝えいただければ、より正確なお時間をお伝えできます。",
  },
  {
    question: "日曜・祝日でも対応してもらえますか？",
    answer: "誠に申し訳ございませんが、日曜・祝日は定休日とさせていただいております。月曜〜土曜の営業時間内（9:00〜17:00）でお願いいたします。",
  },
  {
    question: "代車はありますか？",
    answer: "車検や長時間の整備の際、代車をご用意できる場合がございます。数に限りがございますので、事前にお電話でご確認ください。",
  },
];

export const services: ServiceItem[] = [
  {
    id: "inspection",
    name: "車検・法定点検",
    description: "法定12ヶ月点検から車検整備まで、お客様の安心・安全を第一に対応いたします。",
    icon: "ri-file-list-3-line",
  },
  {
    id: "maintenance",
    name: "一般整備・メンテナンス",
    description: "オイル交換、ブレーキ交換、タイヤ交換など、日頃のお手入れから故障修理まで幅広く対応。",
    icon: "ri-tools-line",
  },
  {
    id: "body",
    name: "板金・塗装",
    description: "キズ・ヘコミの修理から全塗装まで、職人技で愛車を美しく蘇らせます。",
    icon: "ri-paint-brush-line",
  },
  {
    id: "led",
    name: "LEDヘッドライト取付",
    description: "スフィアライト製品の取付を承ります。プロの技術で確実に、短時間で施工いたします。",
    icon: "ri-lightbulb-line",
  },
  {
    id: "tire",
    name: "タイヤ・ホイール",
    description: "タイヤ交換、ホイール取付、アライメント調整まで、足回りのこともお任せください。",
    icon: "ri-disc-line",
  },
  {
    id: "sales",
    name: "中古車販売",
    description: "厳選した良質な中古車を取り揃えております。ご予算・ご希望に合わせてご提案いたします。",
    icon: "ri-car-line",
  },
];

export const steps: StepItem[] = [
  {
    step: 1,
    title: "お電話でご予約",
    description: "お電話にてご来店日時をお知らせください。急な故障の場合もお気軽にご相談ください。",
    icon: "ri-phone-line",
  },
  {
    step: 2,
    title: "ご来店・点検",
    description: "お車をご持参いただき、症状確認・点検を行います。見積もりは無料です。",
    icon: "ri-search-line",
  },
  {
    step: 3,
    title: "整備・完了",
    description: "ご承認いただいた内容で整備を行い、完了後にお渡しします。安心してお乗りいただけます。",
    icon: "ri-checkbox-circle-line",
  },
];

export const voices: VoiceItem[] = [
  {
    name: "T.K",
    age: "40代",
    car: "トヨタ プリウス",
    comment: "車検でお世話になりました。予約もスムーズで、作業も丁寧でした。次もお願いしたいと思います。",
  },
  {
    name: "M.S",
    age: "30代",
    car: "ホンダ フィット",
    comment: "LEDヘッドライトの取付をお願いしました。30分程度で終わり、夜道が明るくなって安心感が増しました。",
  },
  {
    name: "Y.A",
    age: "50代",
    car: "日産 エクストレイル",
    comment: "板金の相談に乗ってもらい、仕上がりに大満足です。対応も感じが良く、近所の方にも勧めたいです。",
  },
];

export const noticeItems = [
  "営業時間は月曜〜土曜 9:00〜17:00となります。日曜・祝日は定休日です。",
  "ご来店の際は、事前にお電話でご予約いただくことをおすすめしております。",
  "取付サービスをご利用の場合、作業内容・工賃は店舗にて直接お支払いください。",
  "作業ミスによるトラブルなどの責任範囲については、事前に店舗にてご確認ください。",
];